import React, { useState } from 'react';
import { useFormik } from 'formik';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import StatusRadioGroup from '../StatusRadioGroup/StatusRadioGroup';
import UserInfo from '../UserInfo/UserInfo';
import SuccessDialog from '../SuccessDialog/SuccessDialog';
import FooterInformation from '../FooterInformation/FooterInformation';
import AdditionalInformation from '../AdditionalInformation/AdditionalInformation';
import ConfirmationText from '../ConfirmationText/ConfirmationText';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import { postVaccinationResponse } from '../../lib/TrainServletService';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useSnackbar } from 'notistack';
import schema from './schema';



const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
	},
	wrapper: {
		margin: theme.spacing(1),
		position: 'relative',
	},
	buttonProgress: {
		color: green[500],
		position: 'absolute',
		top: '50%',
		left: '50%',
		marginTop: -12,
		marginLeft: -12,
	},
}));


export const VaccinationStatus = () => {
	const classes = useStyles();
	const [successDialogOpen, setSuccessDialogOpen] = useState(false);
	const { enqueueSnackbar } = useSnackbar();
	const printing = useMediaQuery('print');
	const padding = printing ? 0 : 1;

	const submit = async (values, formik) => {
		try {
			let { userID, lastFour, vaccinationStatus } = values;
			let params = { UserID: userID, SSN: lastFour, vaccinationStatus: vaccinationStatus, insertvaccinationcertification: '' };
			await postVaccinationResponse(params);
			setSuccessDialogOpen(true);
			formik.resetForm();
		} catch (error) {
			console.error(error);
			formik.setSubmitting(false);
			enqueueSnackbar('Could not submit your response at this time. \n Your credentials could be incorrect or there could be a problem with the application. \n Please check your information and try again.', { variant: 'error', autoHideDuration: 10000, style: { whiteSpace: 'pre-line' } });
		}

	};
	const formik = useFormik({
		initialValues: {
			userID: '',
			lastFour: '',
			vaccinationStatus: ''
		},
		validationSchema: schema,
		onSubmit: submit
	});

	return (
		<Container maxWidth='md' component={Box} p={1}  justifyContent='center' >
			<Box id="vaccination-status-form">
				<Paper elevation={2}>
					<Box p={padding}>
						<Typography variant='h3' align='center' gutterBottom>SRS Certification of Vaccination</Typography>
						<Typography variant='h4'>Certification of Vaccination</Typography>
						<Typography variant='body1'>The purpose of this form is to take steps to prevent the spread of COVID-19, to protect the health and safety of all Federal employees, onsite contractors, visitors to Federal buildings or Federally controlled indoor workspaces, and other individuals interacting with the Federal workforce.
							If you fail to submit this signed attestation or any required negative COVID-19 test, you may be denied entry to a Federal facility.</Typography>
					</Box>

					<Box p={padding} display='flex' justifyContent='center'>
						<Box>
							<Typography variant='h4' align='center'>My Vaccination Status</Typography>
							<Typography variant='subtitle1'>By checking the box below, I declare that the following statement is true:</Typography>
							<StatusRadioGroup formik={formik} />
						</Box>
					</Box>
					<Box p={padding} display='flex' justifyContent='center'>
						<ConfirmationText />
					</Box>
					<Box px={padding} display='flex' justifyContent='center' displayPrint="none">
						<UserInfo formik={formik} />
					</Box>
					<Box paddingY={padding} display='flex' justifyContent='center' displayPrint="none">
						<div className={classes.wrapper}>
							<Button
								variant="contained"
								color="primary"
								disabled={formik.isSubmitting}
								onClick={formik.handleSubmit}
							>
								Submit
							</Button>
							{formik.isSubmitting && <CircularProgress size={24} className={classes.buttonProgress} />}
						</div>
					</Box>
					<Box paddingX={padding} marginBottom={4} paddingBottom={4}>
						<hr />
						<FooterInformation />
					</Box>
				</Paper>

				<Paper component={Box} p={padding} display='flex' justifyContent='center' elevation={2}>
					<Box px={1}>
						<AdditionalInformation />
					</Box>
				</Paper>
			</Box>
			<SuccessDialog open={successDialogOpen} onConfirm={() => { setSuccessDialogOpen(false); }} />
		</Container>

	);

};